import React, { useState, useEffect } from 'react';

interface ChatbotEntryPointProps {
    onClick: () => void;
    isActive?: boolean;
}

/**
 * Sograd avatar — replace with the actual image path.
 * Drop the avatar image at: src/features/chatbot/assets/sograd-avatar.png
 */
// @ts-ignore
import sogradAvatar from '~/features/chatbot/assets/sograd-avatar.png';

/**
 * Floating entry point with Sograd's avatar and an initial "Do you have a question?" bubble.
 * The bubble appears after a short delay and can be dismissed by clicking it or the avatar.
 */
const ChatbotEntryPoint = ({ onClick, isActive }: ChatbotEntryPointProps) => {
    const [showBubble, setShowBubble] = useState(false);
    const [bubbleDismissed, setBubbleDismissed] = useState(false);

    // Show the bubble after 2 seconds on first load (if chat isn't already open)
    useEffect(() => {
        if (isActive || bubbleDismissed) {
            setShowBubble(false);
            return;
        }

        const timer = setTimeout(() => {
            setShowBubble(true);
        }, 2000);

        return () => clearTimeout(timer);
    }, [isActive, bubbleDismissed]);

    const handleClick = () => {
        setShowBubble(false);
        setBubbleDismissed(true);
        onClick();
    };

    return (
        <div
            className="position-fixed display-flex align-items-center gap-10"
            style={{ bottom: '24px', right: '24px', zIndex: 1500 }}
            data-testid="chatbot-entry-point-container"
        >
            {/* Popup bubble message */}
            {showBubble && !isActive && (
                <div
                    className="rounded padding-10 padding-left-20 padding-right-20 text-color-white cursor-pointer text-size-14"
                    style={{
                        backgroundColor: '#9b2d6b',
                        borderRadius: '24px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        whiteSpace: 'nowrap',
                    }}
                    onClick={handleClick}
                    role="button"
                    tabIndex={0}
                    data-testid="chatbot-bubble-message"
                >
                    Do you have a question?
                </div>
            )}

            {/* Avatar button */}
            <button
                className="btn position-relative display-flex align-items-center justify-content-center"
                style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '50%',
                    padding: '0',
                    border: 'transparent',
                    overflow: 'hidden',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    background: 'white',
                }}
                onClick={handleClick}
                data-testid="chatbot-entry-point"
                aria-label="Do you have a question? Open Sograd"
            >
                {isActive ? (
                    <span className="rioglyph rioglyph-remove text-size-20 text-color-darkest" aria-hidden="true" />
                ) : (
                    <img
                        src={sogradAvatar}
                        alt="Sograd"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                )}
            </button>
        </div>
    );
};

export default ChatbotEntryPoint;
